import { z } from "zod";

export const TmpIdSchema = z
  .string()
  .regex(
    /^tmp_(machine|node|edge|param|sensor_link|compat)_[0-9a-fA-F-]{36}$/,
    "tmp_id deve seguir 'tmp_<kind>_<uuid>'"
  );
export type TmpId = z.infer<typeof TmpIdSchema>;
